import React from "react";

export interface TileData {
  key: string;
  label: string;
  /** Already formatted — a dash when the metric has no basis of calculation */
  value: string;
  unit?: string;
  foot?: string;
  /**
   * What the number covers, for a tile whose name reads narrower than what it measures. Shown on
   * hover, the same way the vehicle, ranking and daily-series cells already explain themselves.
   */
  hint?: string;
}

interface TotalsTilesProps {
  tiles: TileData[];
}

/** Fleet totals of the period, including the two parcels the fuel splits into. */
const TotalsTiles: React.FC<TotalsTilesProps> = ({ tiles }) => (
  <div className="tiles">
    {tiles.map((tile) => (
      <div className="tile" key={tile.key} title={tile.hint}>
        <div className="tile-label">{tile.label}</div>
        <div className="tile-value">
          {tile.value}
          {tile.unit && <span className="unit">{tile.unit}</span>}
        </div>
        {tile.foot && <div className="tile-foot">{tile.foot}</div>}
      </div>
    ))}
  </div>
);

export default TotalsTiles;
